import { render } from "./ComTooltip.vue?vue&type=template&id=f4913d9c&ts=true"
import script from "./ComTooltip.vue?vue&type=script&lang=ts"
export * from "./ComTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__